"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeeksForMonth = void 0;
const getWeeksForMonth = date => {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  // Get the first Sunday before or on the start of the month
  const start = new Date(startOfMonth);
  start.setDate(start.getDate() - start.getDay());
  // Get the last Saturday after or on the end of the month
  const end = new Date(endOfMonth);
  end.setDate(end.getDate() + (6 - end.getDay()));
  const weeks = [];
  const current = new Date(start);
  while (current <= end) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      week.push({
        date: new Date(current),
        isCurrentMonth: current.getMonth() === date.getMonth()
      });
      current.setDate(current.getDate() + 1);
    }
    weeks.push(week);
  }
  return weeks;
};
exports.getWeeksForMonth = getWeeksForMonth;
